import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

const services = [
  {
    title: "iOS App Development",
    description:
      "We create high-performance iOS apps using Swift and SwiftUI, tailored for seamless Apple ecosystem integration.",
    icon: "\ud83c\udf1f",
  },
  {
    title: "Android App Development",
    description:
      "From Kotlin to Java, we build scalable Android apps optimized for diverse devices and user experiences.",
    icon: "\ud83d\udcf1",
  },
  {
    title: "Cross-Platform Apps",
    description:
      "Using Flutter and React Native, we develop apps that work flawlessly across both iOS and Android platforms.",
    icon: "\ud83d\udef0\ufe0f",
  },
  {
    title: "UI/UX Design",
    description:
      "Our designers craft intuitive mobile interfaces that offer stunning visuals and easy navigation.",
    icon: "\ud83c\udfa8",
  },
  {
    title: "App Maintenance & Updates",
    description:
      "Ongoing support and performance enhancements to keep your app secure, fast, and up-to-date.",
    icon: "\u267b\ufe0f",
  },
];

export default function AppDevelopmentServices() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
  return (
    <main className="bg-white text-gray-800">
      <Helmet>
        <title>App Development Services | Codexa</title>
        <meta
          name="description"
          content="Discover Codexa's mobile app development services for iOS, Android, and cross-platform solutions with stunning UI/UX."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-indigo-600 text-white py-20 px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl font-bold">Mobile App Development</h1>
          <p className="mt-4 text-lg md:text-xl text-indigo-100">
            Codexa delivers mobile-first solutions to bring your app ideas to life with speed and precision.
          </p>
        </motion.div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-6 max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white border border-gray-200 shadow-md rounded-2xl p-6 hover:shadow-xl transition"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold text-indigo-600 mb-2">{service.title}</h3>
              <p className="text-gray-700">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gray-100 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto px-4"
        >
          <h2 className="text-3xl font-bold text-indigo-600 mb-4">
            Launch Your App with Codexa
          </h2>
          <p className="text-gray-700 mb-6">
            Partner with us to create apps that engage users and drive growth across all platforms.
          </p>
          <a
            href="/contact"
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-full text-lg transition shadow-lg"
          >
            Get in Touch
          </a>
        </motion.div>
      </section>
    </main>
  );
}
